import { Routes } from '@angular/router';
import { LandingPageComponent } from './features/landing/pages/landing-page.component';
import { LoginPageComponent } from './features/login/pages/login-page.component';
import { landingGuard } from './shared/guards/landing.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ({ queryParams }) => {
      const id = queryParams['id'];
      return id ? `/login?id=${id}` : '/login';
    },
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'landing',
    component: LandingPageComponent,
    canActivate: [landingGuard],
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
